import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Card, Button } from '@material-ui/core';

import SimpleDialog from './SimpleDialog/SimpleDialog'
import AlertDialog from './AlertDialog/AlertDialog';
import AlertDialogSlide from './AlertDialogSlide/AlertDialogSlide';
import FormDialog from './FormDialog/FormDialog'

const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '3px 6px',
        width: '100%'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey'
    },
    divContent: {
        padding: 12,
    },
    cardBody: {
        height: '100%'
    }
}));

function ModalComp() {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [SimpleDialogValue, setSimpleDialogValue] = useState("Interested");

    const opner = () => {
        setOpen(true);
    }
    const handleCloseValueReceiver = (value) => {
        setSimpleDialogValue(value);
        setOpen(false);
    }

    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">Modal - Dialogs</Typography>
            </div>
            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                simple dialog
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <Button variant="outlined" color="primary" onClick={opner}>
                                Open simple dialog, select there and update Here
                            </Button>
                            <Typography variant="subtitle1">Selected value from modal: {SimpleDialogValue}</Typography>
                            <SimpleDialog open={open} selectedValue={SimpleDialogValue}
                                onClose={handleCloseValueReceiver} />
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Alert Dialog
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <AlertDialog />
                        </div>
                    </Card>
                </Grid>

            </Grid>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Slide Alert Dialog
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <AlertDialogSlide />
                        </div>
                    </Card>

                </Grid>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Form Dialog
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <FormDialog />
                        </div>
                    </Card>
                </Grid>

            </Grid>


        </div>

    )
}

export default ModalComp
